export default "__VITE_ASSET__BDMSFMxa__"